import axios from "axios";

const fetchAddressByCep = (cep) =>
  axios
    .get(`https://viacep.com.br/ws/${cep.replace(/\D/g, "")}/json`)
    .then((response) => response.data);

export { fetchAddressByCep };
